/**
 * @author Harshitha.k
 * @description 
 */

import React, { Fragment, useEffect, useState ,useRef} from 'react';
import moment from 'moment';
import cloneDeep from 'lodash.clonedeep';
import { connect } from 'react-redux';
import ReactEcharts from '../../Echarts/Echarts';
import { Tag } from 'antd';
import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import { objectOfObject } from '../../../Mock/MockJson';
import { config } from '../../constant';

const GuageRingWithCounter = (props) => {
  const getOption = () => {
    let { graphprops } = props;
    return {
      progress: {
        show: true,
        overlap: false,
        roundCap: true,
        clip: false,
        itemStyle: {
          borderWidth: 1,
          borderColor: '#464646',
        },
      },
      toolbox: {
        showTitle: true,
        itemSize: 25,
        feature: {
          saveAsImage: {
            title: 'download',
            backgroundColor: props.theme.algorithm === "dark" ? 'black' : 'white',
            name: graphprops && graphprops.title ? graphprops.title : '',
            iconStyle: {
              color: 'none',
              borderColor: '#8c8c8c',
              borderWidth: 2,
            },
          },
        },
      },
    };
  };
  const getInitialState = () => ({
    option: getOption(),
  });

  const [option, setOption] = useState(getInitialState());
  const [refreshDateTime, setRefreshDateTime] = useState(moment());
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);
  const [requestCheck, setRequestCheck] = useState(true);
  let abortController = useRef(new window.AbortController());


  const fetchData = async () => {
    let {
      graphprops,
      selectionDate,
      selectionMonth,
      DeviceCode,
      selectionDateRange,
      dayMonthYear,
      currentTimeZone,
    } = props;

    let json = [];
    let series = [];
    let sampleJson = [];
    let errorInAPI = false;
    let noDataInDB = false;

    setRequestCheck(false);

    if (graphprops && graphprops.enableMock) {
      json = objectOfObject;
      setRequestCheck(true);
    } else {
      if (graphprops?.graph === 'rangeBar' && graphprops?.currentDateData !== undefined) {
        json = graphprops.currentDateData;
      } else {
         if (
          graphprops &&
          ((graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) ||
          (
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) ||
          (
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) ||
          (
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          (
            (graphprops.DashboardLevelSelection === 'deviceSelection' ||
              graphprops.GraphLevelSelection === 'deviceSelection') &&
            DeviceCode)
        ) {
          json = await getChartDataWithSelection({
            graphprops,
            selectionDate,
            selectionMonth,
            selectionDateRange,
            ...(DeviceCode ? { DeviceCode } : {}),
            dayMonthYear,
            abortController :abortController.current,
            currentTimeZone,
          });
          setRequestCheck(true);
        } else if (
          graphprops.GraphLevelSelection === 'none' ||
          graphprops.DashboardLevelSelection === 'none'
        ) {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController:abortController.current,
            ...(DeviceCode ? { DeviceCode } : {}),
            TimeZone: currentTimeZone,
          });
          setRequestCheck(true);
        }
      }
    }

    const queryArray = json?.query;
    const query1Array = json?.query1;

    json =
      queryArray &&
      Array.isArray(queryArray) &&
      queryArray.map((jsonData) => ({
        name: jsonData.Name,
        value: jsonData.Value,
      }));      

    let json1 =
      query1Array &&
      Array.isArray(query1Array) &&
      query1Array.map((jsonData) => ({
        value: jsonData.Value,
      }));

    const Target = [
      {
        value: 80,
        name: 'Target',
        title: {
          offsetCenter: ['-100%', '105%'],
        },
        detail: {
          offsetCenter: ['-100%', '120%'],
        },
      },
    ];
    const Total = [
      {
        value: json1 && json1[0].value,
        detail: {
          offsetCenter: ['0%', '0%'],
        },
      },
    ];

    if (
      (json && json.message) ||
      (Array.isArray(json) && json.length === 0 && graphprops.enableMock !== true)
    ) {
      if (json.message) {
        errorInAPI = true;
      } else if (json.length === 0) {
        noDataInDB = true;
      }
    } else {
      sampleJson = [
        {
          title: {
            offsetCenter: ['-30%', '105%'],
          },
          detail: {
            offsetCenter: ['-30%', '120%'],
          },
        },
        {
          title: {
            offsetCenter: ['30%', '105%'],
          },
          detail: {
            offsetCenter: ['30%', '120%'],
          },
        },
        {
          title: {
            offsetCenter: ['100%', '105%'],
          },
          detail: {
            offsetCenter: ['100%', '120%'],
          },
        },
      ];
      let finalJson = [];
      json &&
        Array.isArray(json) &&
        json.length > 0 &&
        json.map((item, index) => {
          item.title = sampleJson && sampleJson[index] && sampleJson[index]['title'];
          item.detail = sampleJson && sampleJson[index] && sampleJson[index]['detail'];
          finalJson.push(item);
          return {};
        });

      const newOption = cloneDeep(option);
      if (json && Array.isArray(json) && json[0]) {
        series.push(
          {
            type: 'gauge',
            startAngle: 90,
            endAngle: -270,
            pointer: {
              show: false,
            },
            progress: {
              show: true,
              overlap: false,
              roundCap: true,
              clip: false,
              itemStyle: {
                borderWidth: 1,
                borderColor: '#464646',
              },
            },
            axisLine: {
              lineStyle: {
                width: 30,
              },
            },
            splitLine: {
              show: false,
              distance: 0,
              length: 10,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: false,
              distance: 50,
            },
            data: finalJson,
            title: {
              fontSize: 12,
              color: 'white',
            },
            detail: {
              width: 38,
              height: 10,
              fontSize: 13,
              fontWeight: 'bold',
              color: 'auto',
              borderColor: 'auto',
              borderRadius: 5,
              borderWidth: 1,
              formatter: '{value}%',
            },
          },
          {
            type: 'gauge',
            startAngle: 90,
            endAngle: -270,
            pointer: {
              show: false,
            },
            progress: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            data: Target,
            title: {
              fontSize: 12,
              color: 'white',
            },
            detail: {
              width: 38,
              height: 10,
              fontSize: 13,
              fontWeight: 'bold',
              color: 'auto',
              borderColor: 'auto',
              borderRadius: 5,
              borderWidth: 1,
              formatter: '{value}%',
            },
          },
          {
            type: 'gauge',
            startAngle: 90,
            endAngle: -270,
            pointer: {
              show: false,
            },
            progress: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            data: Total,
            title: {
              fontSize: 12,
              color: 'white',
            },
            detail: {
              width: 38,
              height: 10,
              fontSize: 42,
              fontWeight: 'bold',
              color: 'auto',
              formatter: '{value}%',
            },
          }
        );
      }

      newOption.series = series;
      if (newOption && newOption.series && newOption.series[0]) {
        newOption.series[0].pointer.show = false;
      }

      setOption(newOption);
      setRefreshDateTime(moment());
    }

    setErrorInAPI(errorInAPI);
    setNoDataInDB(noDataInDB);
  };

  useEffect(() => {
    // fetchData();
    const refreshTime = props.graphprops.refreshTime
      ? props.graphprops.refreshTime * 60000
      : config.defaultRefreshTime;

    const interval = setInterval(() => {
      if (requestCheck) {
        fetchData();
      }
    }, refreshTime);

    return () => {
       abortController.current.abort();
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    fetchData();
  }, [
    props.graphprops,
    props.selectionDate,
    props.selectionDateLive,
    props.selectionMonth,
    props.selectionWeek,
    props.DeviceCode,
    props.shift,
    props.selectionDateRange,
    props.dayMonthYear,
    props.dropdownSelection,
    props.dashboardPayload,
    props.AssetCode,
    props.translationCache,
  ]);

  return (
    <Fragment>
      {props.graphprops && props.graphprops.checked === true ? (
        <Tag className="graphTag" color="blue">
          {refreshDateTime ? moment(refreshDateTime).format('YYYY-MM-DD HH:mm:ss') : ''}
        </Tag>
      ) : null}

      {noDataInDB === true || errorInAPI === true ? (
        noDataInDB === true ? (
          <NoRecordComponent />
        ) : (
          <ErrorComponent />
        )
      ) : (
        <ReactEcharts
          id={Math.ceil(Math.random(100, 100000) * 1000)}
          option={option}
          style={{
            height: '90%',
            width: '100%',
          }}
          className="react_for_echarts"
        />
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    theme: state.ThemeReducer,
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.currentTimeZone
  };
};

export default connect(mapStateToProps)(GuageRingWithCounter);
